<script setup lang="ts">import { computed as _computed } from 'vue';

import { AssetSummaryDto, AssetSummaryDtoV2, type MonitorSummaryDto } from '@/api';
import { useRouter } from 'vue-router/composables';
import MonitorPreviewCard from '../monitor-preview-card/Monitor-Preview-Card.vue';
import AssetPreviewCard from '../asset-preview-card/Asset-Preview-Card.vue';

interface EntityPreviewCardProps {
  entity: AssetSummaryDto | MonitorSummaryDto | AssetSummaryDtoV2;
}
const props = defineProps({
  entity: null
});

const router = useRouter();

const is = _computed(() => {
  switch (props.entity.displayedType) {
    case AssetSummaryDto.displayedType.MONITOR:
      return MonitorPreviewCard;
    default:
      return AssetPreviewCard;
  }
});
const routeName = _computed(() => {
  switch (props.entity.displayedType) {
    case AssetSummaryDto.displayedType.MONITOR:
      return 'monitors.rule.overview';
    default:
      return 'data-catalog.asset.overview';
  }
});
const params = _computed(() : any => {
  const routeParams: any = {};
  switch (props.entity.displayedType) {
    case AssetSummaryDto.displayedType.MONITOR:
      routeParams.id = props.entity.urn?.replace('sifflet-rule:', '')!;
      break;
    default:
      routeParams.urn = props.entity.urn!;
      break;
  }
  return routeParams;
});
const assetLink = _computed(() => ({ name: routeName.value, params: params.value }));

const openAsset = () => {
  router.push(assetLink.value);
};

</script>
<template lang="pug">
v-row.border-bottom( @click="openAsset" class="pointer" )
  v-col
    component( :is="is" :entity="entity" )

</template>
